import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Card as CardMaterial,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  FormControlLabel,
  Checkbox,
  CardMedia,
  Tooltip,
  createTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteBanner,
  getBannerById,
  postBanner,
  updateBanner,
} from "../../../../api/banner";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { Autocomplete } from "@material-ui/lab";
import { getLocalidades } from "../../../../api/localidad";
import MultiTabBlock from "../../../components/MultiTabBlock";
import { getUsers } from "../../../../api/user";
import { getInteresados } from "../../../../api/interesado";
import Table, {
  buttonsStyle,
  dateFormatter,
} from "../../../components/tables/table";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import Editor from "../../../components/editor/Editor";
import { SERVER_URL } from "../../../../api";
import PreviewDialog from "../../../components/dialogs/PreviewDialog";
import { Delete, Visibility } from "@material-ui/icons";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ImageStorageSelectorDialog from "../../../components/dialogs/ImageStorageSelectorDialog";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyBanner() {
  return {
    titulo: {},
    imageUrl: {},
    active: true,
  };
}

export default function EditBannerPage() {
  const [banner, setBanner] = useState(getEmptyBanner());
  const imageInputRef = { es: useRef(null), ca: useRef(null) };
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState({});
  const [openPreviewDialog, setOpenPreviewDialog] = useState(null);
  const [openImageSelector, setOpenImageSelector] = useState({});
  const bannerId = useParams().id;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    const fetch = async () => {
      if (!bannerId) {
        disableLoadingData();
        return;
      }
      getBannerById(bannerId)
        .then((res) => {
          if (res.status === 200) {
            const banner = res.data;
            setBanner(banner);

            disableLoadingData();
          }
        })
        .catch((error) => {
          alertError({ error: error, customMessage: "Could not get banner." });
          history.push("/banners");
        });
    };
    fetch();
  }, [bannerId, disableLoadingData, history]);

  function saveBanner() {
    let saveBanner = banner;
    if (!bannerId) {
      postBanner(saveBanner, selectedImage)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "Saved!",
              customMessage: "Banner successfully created.",
            });
            history.push("/banners");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save banner.",
          });
        });
    } else {
      updateBanner(bannerId, saveBanner, selectedImage)
        .then((res) => {
          if (res.status === 200) {
            alertSuccess({
              title: "Saved!",
              customMessage: "Changes successfully saved.",
            });
            history.push("/banners");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save changes.",
          });
        });
    }
  }

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === " ") return;

      if (!banner[element]) banner[element] = {};
      let newText = banner[element];
      newText[lang] = event.target.value;
      setBanner({ ...banner, [element]: newText });
    } else setBanner({ ...banner, [element]: event.target.value });
  };

  const renderStickyButtons = ({
    onBack,
    onSave,
    onDelete,
    setObj,
    obj,
    showDelete = false,
  }) => {
    return (
      <div
        className="sticky-top bg-white border-top shadow-sm"
        style={{
          zIndex: 1000,
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <div className="container-fluid">
          <div className="row py-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                {/* Botón Back */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onBack}
                    variant="outlined"
                    size="medium"
                    className="text-nowrap"
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                </div>

                {/* Botones Save y Delete */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onSave}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                  >
                    Save
                  </Button>

                  {showDelete && (
                    <MuiThemeProvider theme={theme}>
                      <Button
                        onClick={onDelete}
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        className="text-nowrap"
                      >
                        Delete
                      </Button>
                    </MuiThemeProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderMultilanguageTabContent = (lang) => {
    return (
      <>
        <div className="d-flex align-text-center">
          <div className="col-md-6">
            <TextField
              id={`titulo`}
              label="Titulo"
              value={
                banner.titulo && banner.titulo[lang] ? banner.titulo[lang] : ""
              }
              onChange={handleChange("titulo", lang)}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
          </div>
          <div className="col-md-6">
            <CardMaterial>
              {(selectedImage[lang] || banner.imageUrl[lang]) && (
                <CardMedia
                  component="img"
                  alt="New"
                  style={{
                    objectFit: "contain",
                    width: "100%",
                    height: "auto",
                    maxHeight: "600px",
                  }}
                  image={
                    selectedImage[lang]
                      ? URL.createObjectURL(selectedImage[lang])
                      : `${SERVER_URL}/${banner.imageUrl[lang]}`
                  }
                />
              )}
            </CardMaterial>
            <div style={{ display: "flex", gap: "10px", marginTop: "16px", marginBottom: "16px", flexWrap: "wrap" }}>
              <label htmlFor={`upload-media-${lang}`} className="ml-0">
                <input
                  ref={imageInputRef[lang]}
                  style={{ display: "none" }}
                  id={`upload-media-${lang}`}
                  name={`upload-media-${lang}`}
                  type="file"
                  accept={"image/*"}
                  onChange={(e) => {
                    setSelectedImage((pre) => {
                      return { ...pre, [lang]: e.target.files[0] };
                    });
                  }}
                />
                <Button
                  style={{ marginRight: "15px" }}
                  color="secondary"
                  component="span"
                  variant="outlined"
                >
                  {selectedImage[lang] ||
                  (banner.imageUrl[lang] && banner.imageUrl[lang] !== "")
                    ? "cambiar imagen"
                    : "subir imagen"}
                </Button>
              </label>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setOpenImageSelector({ ...openImageSelector, [lang]: true })}
              >
                Seleccionar de galería
              </Button>
            </div>
            {(selectedImage[lang] ||
              (banner.imageUrl[lang] && banner.imageUrl[lang] !== "")) && (
              <>
                <Tooltip title={"Preview"}>
                  <Button
                    size="small"
                    onClick={() => setOpenPreviewDialog(1)}
                    style={{
                      ...buttonsStyle,
                      marginRight: "15px",
                    }}
                  >
                    <Visibility />
                  </Button>
                </Tooltip>
                <PreviewDialog
                  title={"Preview"}
                  open={openPreviewDialog === 1}
                  setOpen={setOpenPreviewDialog}
                  file={selectedImage[lang]}
                  src={
                    selectedImage[lang]
                      ? URL.createObjectURL(selectedImage[lang])
                      : `${SERVER_URL}/${banner.imageUrl[lang]}`
                  }
                />
                <Tooltip title={"Delete"}>
                  <Button
                    size="small"
                    onClick={() => {
                      setSelectedImage((pre) => {
                        return { ...pre, [lang]: null };
                      });
                      setBanner({
                        ...banner,
                        imageUrl: { ...banner.imageUrl, [lang]: null },
                      });
                      if (imageInputRef[lang].current) {
                        imageInputRef[lang].current.value = "";
                      }
                    }}
                  >
                    <Delete />
                  </Button>
                </Tooltip>
              </>
            )}
          </div>
        </div>
      </>
    );
  };
  const renderMultilanguageTabContentEnlace = (lang) => {
    return (
      <>
        <TextField
          id={`enlace`}
          label="Url amigable"
          value={
            banner.enlace && banner.enlace[lang] ? banner.enlace[lang] : ""
          }
          onChange={handleChange("enlace", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
        />
        <TextField
          id={`tituloEnlace`}
          label="Titulo SEO"
          value={
            banner.tituloEnlace && banner.tituloEnlace[lang]
              ? banner.tituloEnlace[lang]
              : ""
          }
          onChange={handleChange("tituloEnlace", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
        />
        <TextField
          id={`descripcionEnlace`}
          label="Descripción SEO"
          value={
            banner.descripcionEnlace && banner.descripcionEnlace[lang]
              ? banner.descripcionEnlace[lang]
              : ""
          }
          onChange={handleChange("descripcionEnlace", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
        />
      </>
    );
  };

  const renderContentDatosGenerales = () => {
    return (
      <>
        <MultilanguageTabBlock
          multilanguageTabContent={renderMultilanguageTabContent}
        />
      </>
    );
  };

  const renderContentEnlace = () => {
    return (
      <>
        <MultilanguageTabBlock
          multilanguageTabContent={renderMultilanguageTabContentEnlace}
        />
      </>
    );
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          {renderStickyButtons({
            onBack: () => history.push("/banners"),
            onSave: saveBanner,
            onDelete: () => setOpenConfirmDialog(true),
            showDelete: !!bannerId,
            setObj: setBanner,
            obj: banner,
          })}
          <CardHeader title="Editar banner"></CardHeader>
          <CardBody>
            <MultiTabBlock
              tabs={[
                {
                  enable: true,
                  title: "Datos Generales",
                  renderContent: renderContentDatosGenerales,
                },
                {
                  enable: bannerId !== undefined,
                  title: "SEO",
                  renderContent: renderContentEnlace,
                },
              ]}
            />

            {/* Checkboxes */}
            <div style={{ marginTop: "20px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={banner.active || false}
                    onChange={() =>
                      setBanner({ ...banner, active: !banner.active })
                    }
                    name="checkActive"
                  />
                }
                label="Active"
              />
            </div>
          </CardBody>
        </Card>
        
        {/* Diálogos de selección de imageStorage para cada idioma */}
        {['es', 'ca'].map(lang => (
          <ImageStorageSelectorDialog
            key={lang}
            open={openImageSelector[lang] || false}
            onClose={() => setOpenImageSelector({ ...openImageSelector, [lang]: false })}
            onSelect={(url) => {
              setBanner({
                ...banner,
                imageUrl: { ...banner.imageUrl, [lang]: url }
              });
              setSelectedImage({ ...selectedImage, [lang]: null });
            }}
            filterType="imagen"
            title={`Seleccionar imagen (${lang.toUpperCase()})`}
          />
        ))}
        
        {bannerId && (
          <>
            <ConfirmDialog
              title={"Are you sure you want to delete this banner?"}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                deleteBanner(bannerId)
                  .then((res) => {
                    if (res.status === 204 || res.status === 200) {
                      alertSuccess({
                        title: "Deleted!",
                        customMessage: "Banner deleted successfully",
                      });
                      history.push("/banners");
                    }
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: "Could not delete banner.",
                    });
                  });
              }}
            />
          </>
        )}
      </>
    );
}
